import { getCurrentPageQueryParams } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import { Map } from 'src/jisu-component/map/Map';

// import './MapDetail.less';

export default class MapDetail extends OfficialPage {

  state = {};

  constructor(props) {
    super(props);
    document.title = '地图';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    var parsed_params = JSON.parse(options.eventParams);
    var new_marker = {};
    new_marker['markers'] = parsed_params;
    new_marker['longitude'] = parsed_params[0].longitude;
    new_marker['latitude'] = parsed_params[0].latitude;
    this.setData(new_marker);
  }

  render() {
    const {
      longitude,
      latitude,
      markers,
    } = this.state;
    return (
      <div className="map-detail">
        <TopNav title="地图" />
        <Map
          longitude={longitude}
          latitude={latitude}
          scale="17"
          markers={markers} style={{
            width: '100%',
            height: '100%'
          }}
      ></Map>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/map-detail/MapDetail.jsx